export const CODE_HOOVER_REPOSITORY_URL = 'https://github.com/formation-res/code-hoover-2.0'
export const ORIGINAL_CODE_HOOVER_REPOSITORY_URL = 'https://github.com/jillesvangurp/code-hoover'
export const CODE_HOOVER_APP_URL = 'https://code-hoover-2.pages.dev'
